import { gql } from '@apollo/client';
export const SUBSCRIPTION_ENTITIES_AFFECTED = gql`
  subscription EntitiesAffected {
    entitiesAffected {
      name
      entities {
        id
        updatedTime
      }
      operationType
      projectId
    }
  }
`;
